module.exports = __webpack_public_path__ + "static/media/07-colorGreenImg.b3406787.png";